import { Injectable } from '@angular/core';
import { Auth, User, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { BehaviorSubject, Observable, firstValueFrom, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly auth: Auth;
  private readonly userSubject = new BehaviorSubject<User | null>(null);
  private readonly authReadySubject = new BehaviorSubject<boolean>(false);

  readonly user$: Observable<User | null> = this.userSubject.asObservable();
  readonly authReady$: Observable<boolean> = this.authReadySubject.asObservable();
  readonly isLoggedIn$: Observable<boolean> = this.user$.pipe(map(Boolean));

  constructor() {
    this.auth = getAuth();

    onAuthStateChanged(this.auth, (user) => {
      this.userSubject.next(user);
      this.authReadySubject.next(true);
    });
  }

  login(email: string, password: string): Promise<User> {
    return signInWithEmailAndPassword(this.auth, email.trim(), password).then((credential) => {
      this.userSubject.next(credential.user);
      this.authReadySubject.next(true);

      return credential.user;
    });
  }

  logout(): Promise<void> {
    return signOut(this.auth).then(() => {
      this.userSubject.next(null);
    });
  }

  async isLoggedIn(): Promise<boolean> {
    return Boolean(await firstValueFrom(this.user$));
  }
}
